<section class="privacy-page">
  <div class="privacy-shell">
    <p class="eyebrow">Privacy Policy</p>
    <h1>How Advors Agency handles your information</h1>
    <p class="intro">
      This Privacy Policy explains what information may be collected through this website, how it may be used,
      and the choices available to you when you contact Advors Agency.
    </p>

    <div class="policy-card">
      <div class="policy-meta">
        <span>Effective date</span>
        <strong>{{ lastUpdated }}</strong>
      </div>

      <div class="policy-block">
        <h2>Information we may collect</h2>
        <p>
          When you use the contact form, you may voluntarily provide your name, email address or phone number,
          project details, and the services you are interested in.
        </p>
        <p>
          We may also receive limited technical information that is typically collected by websites, such as browser,
          device, and usage data, through hosting, analytics, or security tools used to keep the website available and safe.
        </p>
      </div>

      <div class="policy-block">
        <h2>How we use information</h2>
        <p>We use the information you share to review inquiries, respond to requests, discuss potential projects, and improve the website experience.</p>
        <p>We do not sell your personal information.</p>
      </div>

      <div class="policy-block">
        <h2>Sharing of information</h2>
        <p>
          Information may be shared only when reasonably necessary to operate the website, communicate with you,
          comply with legal obligations, or protect the rights, safety, and integrity of Advors Agency and its users.
        </p>
      </div>

      <div class="policy-block">
        <h2>External links</h2>
        <p>
          This website includes links to third-party platforms such as LinkedIn, Instagram, YouTube, and Facebook.
          Once you leave this website, your interaction with those services is governed by their own terms and privacy policies.
        </p>
      </div>

      <div class="policy-block">
        <h2>Data retention</h2>
        <p>
          Personal information is retained only for as long as reasonably necessary to handle your inquiry,
          maintain business records, resolve disputes, or meet legal requirements.
        </p>
      </div>

      <div class="policy-block">
        <h2>Your choices</h2>
        <p>
          You may contact Advors Agency to request access, correction, or deletion of personal information you have submitted,
          subject to any legal or operational obligations that require retention.
        </p>
      </div>

      <div class="policy-block">
        <h2>Policy updates</h2>
        <p>
          This Privacy Policy may be updated from time to time. Any changes will be posted on this page with the updated effective date.
        </p>
      </div>

      <div class="policy-block">
        <h2>Contact</h2>
        <p>
          For privacy-related questions, please contact Advors Agency through the website contact form or official social media channels listed in the footer.
        </p>
      </div>
    </div>
  </div>
</section>
